import React from "react"
import styled, { css } from "styled-components"
import ProgressiveImage from "react-progressive-image"

import { Box, BoxProps } from "components/box"

type InheritSizes = {
  inheritSizes?: boolean
}
type ImageProps = BoxProps & React.HTMLProps<HTMLImageElement> & InheritSizes
type ResponsiveImageProps = ImageProps & { image: Image }
type ProgressiveResponsiveImageProps = ImageProps & { image: Image & { small: string } }

const Img = styled.img<InheritSizes>`
  ${props =>
    props.inheritSizes &&
    css`
      height: inherit;
      width: inherit;
    `}
`

type Image = {
  standard: string
  retina: string
}

function Image({ src, inheritSizes, ...styledProps }: ImageProps) {
  return (
    <Box display="inline-block" {...styledProps}>
      <Img src={src} inheritSizes={inheritSizes} />
    </Box>
  )
}

export function ResponsiveImage({ image, ...styledProps }: ResponsiveImageProps) {
  return (
    <Box display="inline-block" {...styledProps}>
      <img srcSet={`${image.retina} 2x, ${image.standard} 1x`} src={image.standard} />
    </Box>
  )
}

export const ProgressiveResponsiveImage: React.FC<ProgressiveResponsiveImageProps> = ({ image, ...styledProps }) => (
  <Box display="inline-block" {...styledProps}>
    <ProgressiveImage src={image.standard} placeholder={image.small}>
      {/* use new URL(...) to prevent server side rendering from injecting an absolute URL */}
      {(src: string) => (
        <ResponsiveImage
          image={{
            standard: new URL(src, window.location.toString()).pathname,
            retina: new URL(src, window.location.toString()).pathname
          }}
        />
      )}
    </ProgressiveImage>
  </Box>
)

export const RoundImage = styled(Image)`
  img {
    object-fit: cover;
    border-radius: 50%;
  }
`

export const RoundedRectangleImage = styled(Image)`
  img {
    object-fit: cover;
    border-radius: ${props => props.theme.space[1]};
  }
`

export default Image
